import { SizeHeaderId } from 'owa-mail-group-headers';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { trace } from 'owa-trace';
import strings from 'owa-strings/owa-mail-strings';
var sizeGroupHeaders = [];
export function initializeSizeGroupHeaders() {
    sizeGroupHeaders.push({
        headerId: SizeHeaderId.Tiny,
        headerText: function () { return strings.sizeTinyHeader; },
        greaterThanSize: 0,
    });
    sizeGroupHeaders.push({
        headerId: SizeHeaderId.Small,
        headerText: function () { return strings.sizeSmallHeader; },
        greaterThanSize: 1024 * 10,
    });
    sizeGroupHeaders.push({
        headerId: SizeHeaderId.Medium,
        headerText: function () { return strings.sizeMediumHeader; },
        greaterThanSize: 1024 * 25,
    });
    sizeGroupHeaders.push({
        headerId: SizeHeaderId.Large,
        headerText: function () { return strings.sizeLargeHeader; },
        greaterThanSize: 1024 * 100,
    });
    sizeGroupHeaders.push({
        headerId: SizeHeaderId.VeryLarge,
        headerText: function () { return strings.sizeVeryLargeHeader; },
        greaterThanSize: 1024 * 500,
    });
    sizeGroupHeaders.push({
        headerId: SizeHeaderId.Huge,
        headerText: function () { return strings.sizeHugeHeader; },
        greaterThanSize: 1024 * 1024,
    });
    sizeGroupHeaders.push({
        headerId: SizeHeaderId.Enormous,
        headerText: function () { return strings.sizeEnormousHeader; },
        greaterThanSize: 1024 * 1024 * 5,
    });
}
/**
 * Get GroupHeader for row
 * @param rowKey rowKey for which we want to lookup time group range
 * @param tableView tableView
 * @return group header
 */
export default function getGroupHeaderForSortBySize(rowKey, tableView) {
    if (sizeGroupHeaders.length == 0) {
        initializeSizeGroupHeaders();
    }
    var rowSize = MailRowDataPropertyGetter.getSize(rowKey, tableView);
    for (var i = sizeGroupHeaders.length - 1; i >= 0; i--) {
        if (rowSize > sizeGroupHeaders[i].greaterThanSize) {
            return sizeGroupHeaders[i];
        }
    }
    trace.error('getGroupHeaderForSortBySize: a row should have certain size');
    return {
        headerText: sizeGroupHeaders[0].headerText,
        headerId: sizeGroupHeaders[0].headerId,
    };
}
//# sourceMappingURL=getGroupHeaderForSortBySize.js.map